//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/ugmath.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CreateMachineSpindleObjects",1,0],[0,"DeleteUnsupportedDevices",1,0],[1,"Geometry",0,"SelectNXObjectList",1],[0,"Layer",1,0],[0,"LayerOptions",1,0],[0,"PartMountJunction",1,"CartesianCoordinateSystem",0],[0,"Positioning",1,0]],[[[],"LoadMachinePreview",{R_:{machinePart:"Part"}},0,0],[[],"RemoveMachinePreview",{},0,0],[["workPart","machinePart","position"],"ShowMachinePreview",{},3,0]],[]];
SPLM.CAM.NcmctPartMountingBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.NcmctPartMountingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.NcmctPartMountingBuilder.PositioningTypes = Object.freeze({
    "OrientMachineZeroToMainMcs" : "OrientMachineZeroToMainMcs", "UseAssemblyPositioning" : "UseAssemblyPositioning", "UsePartMountJunction" : "UsePartMountJunction", "UseOldMachineTransformation" : "UseOldMachineTransformation", "KeepAssemblyConstraints" : "KeepAssemblyConstraints", "PositionPartOnMachine" : "PositionPartOnMachine"});

SPLM.CAM.NcmctPartMountingBuilder.LayerTypes = Object.freeze({
    "Original" : "Original", "OriginalMakeVisible" : "OriginalMakeVisible", "Work" : "Work", "AsSpecified" : "AsSpecified"});

export default SPLM;